<style lang="sass">
.box-fields
  display: grid
  grid-template-columns: 48% 48%
  grid-gap: 15px
</style>

<template lang="pug">
v-container.pa-4
  v-toolbar(elevation=0)
    v-toolbar-title
      h3 Evento - {{event.name}}
  div.data-section
    div.space-btw
      h3 SOBRE
      v-btn(icon @click='update = !update')
        v-icon mdi-pencil
    div.my-2
      span.font-weight-bold Nome
      v-text-field(v-model='event.name' :disabled='!update')
    div.my-2
      span.font-weight-bold Serial
      v-text-field(v-model='event.serial' disabled)
    div
      span.font-weight-bold Início
      div.box-fields
        div
          v-menu(ref='menuS' v-model='menuSTime' :close-on-content-click='false' :nudge-right='40' :return-value.sync='startDate.time' transition='scale-transition' offset-y='' max-width='290px' min-width='290px')
            template(v-slot:activator='{ on }')
              v-text-field(v-model='startDate.time' label='Horário' prepend-icon='mdi-calendar-clock' :disabled='!update' v-on='on')
            v-time-picker(v-if='menuSTime' v-model='startDate.time' full-width='' @click:minute='$refs.menuS.save(startDate.time)')
        div
          v-menu(ref='menu1' v-model='menuSDate' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='290px' min-width='290px')
            template(v-slot:activator='{ on }')
              v-text-field(v-model='startDate.date' label='Date' :disabled='!update' prepend-icon='mdi-calendar' v-on='on')
            v-date-picker(v-model='startDate.date' no-title='' @input='menuSDate = false')
    div
      span.font-weight-bold Término
      div.box-fields
        div
          v-menu(ref='menuE' v-model='menuETime' :close-on-content-click='false' :nudge-right='40' :return-value.sync='endDate.time' transition='scale-transition' offset-y='' max-width='290px' min-width='290px')
            template(v-slot:activator='{ on }')
              v-text-field(v-model='endDate.time' label='Horário' prepend-icon='mdi-calendar-clock' :disabled='!update' v-on='on')
            v-time-picker(v-if='menuETime' v-model='endDate.time' full-width='' @click:minute='$refs.menuE.save(endDate.time)')
        div
          v-menu(ref='menu1' v-model='menuEDate' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='290px' min-width='290px')
            template(v-slot:activator='{ on }')
              v-text-field(v-model='endDate.date' label='Date' :disabled='!update' prepend-icon='mdi-calendar' v-on='on')
            v-date-picker(v-model='endDate.date' no-title='' @input='menuEDate = false')
    div.my-2
      span.font-weight-bold Descrição
      v-text-field(v-model='event.description' :disabled='!update')
    div.my-2
      div(v-if='address')
        div.font-weight-bold Endereço
        div
          span CEP
          v-text-field(v-model='address.zip_code' :disabled='!update')
        div.box-fields
          div
            span Rua
            v-text-field(v-model='address.address' :disabled='!update')
          div
            span Número
            v-text-field(v-model='address.address_number' :disabled='!update')
        div.box-fields
          div
            span Complemento
            v-text-field(v-model='address.address_addon' :disabled='!update')
          div
            span Bairro
            v-text-field(v-model='address.neighborhood' :disabled='!update')
        div.box-fields
          div
            span Cidade
            v-text-field(v-model='address.city' :disabled='!update')
          div
            span Estado
            v-select(v-model='address.state' :items='states' :disabled='!update')
    div.my-2.box-fields
      div
        span.font-weight-bold Imagem
        v-text-field(v-model='event.image_url' disabled)
        input(v-if='update' type='file' accept='image/*' @change='onFilePicked')
      div(v-if='imgUrl')
        v-img(:src='imgUrl' width='50%' style='margin: auto')
    div.my-2
      span.font-weight-bold Status
      v-checkbox(v-model='event.suspended' :disabled='true' label='Suspenso')
      v-btn(text @click='updateEventStatus()') {{event.suspended ? 'Ativar evento' : 'Suspender evento'}}
    div.space-btw.mt-4(v-if='update')
      v-btn(@click='update = false' :disabled='wait') Cancelar
      v-btn(@click='updateEvent()' :loading='wait') Salvar
  div.data-section
    div(v-if='!event.suspended')
      div.my-2
        v-btn(text @click='excludeEventDialog = true') Excluir Evento
        v-dialog(v-model='excludeEventDialog' width='600px')
          v-card
            v-card-title Excluir evento permanentemente
              v-btn(text @click='excludeEventDialog = false')
                v-icon mdi-close
            v-card-text
              h3.my-3 Clique em OK abaixo para proceder com a exclusão do evento
            v-card-actions
              v-btn(@click='excludeEvent()' :loading='excludingEvent') OK
      v-snackbar(v-model='eventExcludedSnackbar')
        div Evento excluído com sucesso!
        v-btn(icon @click='eventExcludedSnackbar = false')
          v-icon mdi-close
      v-snackbar(v-model='eventExcludedErrorSnackbar')
        div Error ao excluir evento
        v-btn(icon @click='eventExcludedErrorSnackbar = false')
          v-icon mdi-close
    div(v-if='event.suspended')
      h4.my-4 O evento só pode ser excluido caso não esteja suspenso
  Tickets(:id='id')
  Promoters(:id='id')
  Groups(:id='id')
  TicketsTypes(:id='id')
  v-snackbar(v-model='snackbar')
    div Evento atualizado!
    v-btn(icon @click='snackbar = false')
      v-icon mdi-close
</template>

<script>
import utils from '../utils/requests'
import states from '../utils/states'
import Tickets from '../components/Events/Tickets'
import Promoters from '../components/Events/Promoters'
import Groups from '../components/Events/Groups'
import TicketsTypes from '../components/Events/TicketsTypes'
import moment from 'moment'

moment.locale('pt-br')

export default {
  components: {
    Promoters,
    Groups,
    TicketsTypes,
    Tickets
  },
  data () {
    return {
      id: this.$route.params.id,
      event: {},
      address: {},
      moment: moment,
      menuSDate: false,
      menuSTime: false,
      menuEDate: false,
      menuETime: false,
      startDate: {
        date: '',
        time: ''
      },
      endDate: {
        date: '',
        time: ''
      },
      update: false,
      states: states,
      imgUrl: '',
      wait: false,
      imgUpdated: false,
      snackbar: false,
      excludeEventDialog: false,
      excludingEvent: false,
      eventExcludedSnackbar: false,
      eventExcludedErrorSnackbar: false
    }
  },
  mounted () {
    utils.postAPI('/event/get_event_details', { 'id': this.id }).then(res => {
      console.log('result: ', res)
      this.event = res
      this.imgUrl = this.event.image_url
      console.log(this.event)
      this.formatISODate()
      this.address = this.event.address != null ? this.event.address : {}
    })
  },
  methods: {
    excludeEvent () {
      this.excludingEvent = true
      const data = {
        'event_id': this.event.id
      }
      utils.postAPI('/event/exclude_event', data).then(res => {
        this.excludingEvent = false
        this.excludeEventDialog = false
        this.eventExcludedSnackbar = true
        window.location.reload()
      }).catch(err => {
        console.log(err)
        this.excludingEvent = false
        this.excludeEventDialog = false
        this.eventExcludedErrorSnackbar = true
      })
    },
    formatISODate () {
      this.startDate.date = this.event.start_date.substring(0, 10)
      this.startDate.time = this.event.start_date.substring(11, 19)
      console.log(this.startDate)
      this.endDate.date = this.event.end_date.substring(0, 10)
      this.endDate.time = this.event.end_date.substring(11, 19)
    },
    updateEvent () {
      this.wait = true
      const data = {
        'event_id': this.event.id,
        'event_name': this.event.name,
        'description': this.event.description,
        'start_date': `${this.startDate.date}T${this.startDate.time}`,
        'end_date': `${this.endDate.date}T${this.endDate.time}`,
        'address': this.address,
        'image': this.imgUpdated ? this.imgUrl.slice(22) : ''
      }
      // console.log(JSON.stringify(data))
      utils.postAPI('/event/update_event', data).then(res => {
        console.log('update event: ', res)
        this.wait = false
        this.snackbar = true
        this.update = false
        this.imgUpdated = false
        window.location.reload()
      }).catch(err => {
        console.log(err)
        this.wait = false
      })
    },
    updateEventStatus () {
      this.wait = true
      const data = {
        'id': this.event.id
      }
      utils.postAPI('/event/switch_event_activation', data).then(res => {
        console.log('update event: ', res)
        this.wait = false
        window.location.reload()
      }).catch(err => {
        console.log(err)
        this.wait = false
      })
    },
    onFilePicked (event) {
      const files = event.target.files
      const filename = files[0].name

      if (filename.lastIndexOf('.') <= 0) {
        return alert('Formato de arquivo inválido ')
      }

      const fileReader = new FileReader()

      fileReader.readAsDataURL(files[0])
      fileReader.onload = () => {
        this.imgUrl = fileReader.result // base64 file
        this.imgUpdated = true
      }
    }
  }
}
</script>
